export default {
  get: `query getEvents {
      getEvents
      {
          id,
          name
      }
    }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/event.js